"use client";

import React from "react";
import { Facebook, Instagram, Mail, MapPin, Phone, Twitter } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Badge } from "@/components/ui/badge";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterLinks() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-2">
        {[1, 2, 3, 4].map((_, i) => <li key={i} data-index={i} className="h-4 w-24 bg-muted animate-pulse rounded-sm" />)}
      </ul>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <ul className="space-y-2 text-sm text-muted-foreground font-mono">
        <li data-index={0}>
          <Link to="#" className="hover:text-primary transition-colors">Home</Link>
        </li>
        <li data-index={1}>
          <Link to="#" className="hover:text-primary transition-colors">Fleet & Operations</Link>
        </li>
        <li data-index={2}>
          <Link to="#" className="hover:text-primary transition-colors">Contact</Link>
        </li>
      </ul>;
  }
  return <ul className="space-y-2 text-sm text-muted-foreground font-mono">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="hover:text-primary transition-colors">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  const serviceAreas = ["Dallas Terminal", "Fort Worth Hub", "Arlington Logistics", "Plano Distribution", "Irving Terminal"];
  return <section data-section-id="205764" id="footer" className="dark bg-background text-foreground pt-16 pb-8 border-t-2 border-border">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {}
          <div className="space-y-4">
            <Link to="/">
              
            </Link>
            <p className="text-sm text-muted-foreground leading-relaxed pr-4 font-mono">Legacy Delivery Services provides precision last-mile delivery and regional logistics. Serving DFW with agile fleets and the Southeast with heavy-duty tractor-trailers for industrial supply chains.</p>
          </div>

          {}
          

          {}
          <div>
            <h3 className="font-default font-semibold text-foreground mb-4 text-sm tracking-wider uppercase">
              Navigation
            </h3>
            <MenuProvider menu_id="17">
              <FooterLinks />
            </MenuProvider>
          </div>

          {}
          <div>
            <h3 className="font-default font-semibold text-foreground mb-4 text-sm tracking-wider uppercase">
              Southeast Regional
            </h3>
            <ul className="space-y-3 text-sm text-muted-foreground mb-6 font-mono">
              <li className="flex items-start gap-3">
                <MapPin className="size-4 text-primary shrink-0 mt-0.5" />
                <span>Dallas Regional Hub</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="size-4 text-primary shrink-0" />
                <span>+1-469-590-4364</span>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="size-4 text-primary shrink-0" />
                <span>ops@transitlink.com</span>
              </li>
            </ul>
            <div className="flex gap-4">
              <Link to="#" className="text-muted-foreground hover:text-primary transition-colors" aria-label="Facebook">
                <Facebook className="size-5" />
              </Link>
              <Link to="#" className="text-muted-foreground hover:text-primary transition-colors" aria-label="Twitter">
                <Twitter className="size-5" />
              </Link>
              <Link to="#" className="text-muted-foreground hover:text-primary transition-colors" aria-label="Instagram">
                <Instagram className="size-5" />
              </Link>
            </div>
          </div>
        </div>

        <Separator className="bg-border" />

        <div className="mt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-muted-foreground font-mono">
          <p>© 2026 Legacy Delivery Services. All rights reserved.</p>
          <Badge variant="outline" className="text-xs font-mono border-border text-muted-foreground bg-transparent hover:bg-transparent rounded-sm">
            Industrial Precision
          </Badge>
        </div>
      </div>
    </section>;
}